import styled from 'styled-components';
import { TABLET, NETBOOK, GREY, GREY_DARKEN } from '../../../assets/variable';

export const Wrapper = styled.div`
	position: relative;
	background-color: #ffff;
	.footer {
		padding: 100px 0;
		@media screen and (max-width: ${NETBOOK}) {
			padding: 50px 0;
		}
		a.item-link {
			color: ${GREY};
			text-decoration: none;
			opacity: 0.7;

			@media screen and (max-width: ${NETBOOK}) {
				font-size: 12px;
			}

			&:hover {
				text-decoration: none;
				color: ${GREY_DARKEN};
			}
		}

		&__main-wrapper {
			@media screen and (max-width: ${TABLET}) {
				padding: 0 26px;
			}
		}

		&__logo {
			margin-bottom: 60px;

			@media screen and (max-width: ${TABLET}) {
				margin-bottom: 30px;
			}

			&--image {
				width: 150px;
			}
		}

		&__copyright {
			padding-top: 3em;

			@media screen and (max-width: ${TABLET}) {
				display: none;
			}
		}

		&__wrapper {
			display: flex;
			flex-direction: column;
		}

		&__nav {
			display: flex;

			@media screen and (max-width: ${TABLET}) {
				flex-direction: column;
			}

			&__items {
				display: flex;
				flex-direction: column;
				width: 25%;

				@media screen and (max-width: ${TABLET}) {
					width: 100%;
					margin: 16px 0;
				}

				&--title {
					margin-bottom: 20px;

					@media screen and (max-width: ${TABLET}) {
						margin-bottom: 8px;
					}

					@media screen and (max-width: ${NETBOOK}) {
						font-size: 12px;
					}
				}

				&--link {
					color: ${GREY};
					text-decoration: none;
					opacity: 0.7;

					@media screen and (max-width: ${NETBOOK}) {
						font-size: 12px;
					}

					&:hover {
						text-decoration: none;
						color: ${GREY_DARKEN};
					}
				}
			}
		}

		&__info {
			display: flex;
			flex-direction: column;

			&__title {
				margin-bottom: 20px;

				@media screen and (max-width: ${NETBOOK}) {
					font-size: 12px;
				}
			}

			&__text {
				opacity: 0.7;

				@media screen and (max-width: ${NETBOOK}) {
					font-size: 12px;
				}
			}

			&__sns {
				margin-top: 16px;

				@media screen and (max-width: ${NETBOOK}) {
					margin-top: 8px;
				}

				&--link {
					margin: 0 16px;

					&:first-child {
						margin: 0;
					}

					&:last-child {
						margin: 0;
					}
				}

				&--image {
					width: 20px;
				}
			}
		}
	}
`;

export default Wrapper;
